module.exports = __webpack_public_path__ + "static/media/gogo-partitura-0.11ed6eba.png";